import { createGetRequest } from '_helpers';

export async function getAppConfig() {
    return createGetRequest("app_getConfig")
        .then(res => res.data)
        .then(({ success, data, errorMsg }) => {
            return { response: success, data, errorMsg };
        })
}